<template>
  <div class="ticket-wrapper">
    <table width="716" cellpadding="4" cellspacing="0" class="kodtkt-table">
      <colgroup>
        <col width="109">
        <col width="79">
        <col width="106">
        <col width="166">
        <col width="105">
        <col width="104">
      </colgroup>
      <tbody>
        <tr>
          <td colspan="6" width="708" class="kodtkt-cell-bordered-none">
            <span class="kodtkt-font-bold">{{ $t('boarding.kodrive.title') }}</span>
            <span class="kodtkt-font-bold">{{ common.orderNum }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="6" width="708" class="kodtkt-cell-bordered-bottom">
            <span class="kodtkt-font-italic">{{ $t('boarding.kodrive.desc-blank') }}</span>
          </td>
        </tr>
        <tr>
          <td rowspan="3" width="109" class="kodtkt-cell-bordered-bottom-left kodtkt-cell-align-center kodtkt-cell-valign-middle">
            <span><img alt="QRcode" :src="QRCodeImg" name="QRCode" width="88" height="88" /></span>
          </td>
          <td colspan="5" width="591" class="kodtkt-cell-bordered-no-top">
            <span class="kodtkt-font-bold kodtkt-margin-left">{{ $t('boarding.kodrive.blank') }}</span>
            <span class="kodtkt-font-bold">{{ ticket.ticketNum }}</span>
          </td>
        </tr>
        <tr>
          <td rowspan="2" width="79" valign="top" class="kodtkt-cell-bordered-bottom-left">
            <p>
              <span class="kodtkt-font-italic kodtkt-margin-left">{{ $t('boarding.kodrive.route') }}</span>
              <br>
              <span class="kodtkt-font-bold kodtkt-margin-left">{{ ticket.raceNum }}</span>
            </p>
          </td>
          <td colspan="2" width="280" class="kodtkt-cell-bordered-bottom-left">
            <p>
              <span class="kodtkt-font-italic kodtkt-margin-left">{{ $t('boarding.kodrive.route-name') }}</span>
              <br>
              <span class="kodtkt-font-bold kodtkt-margin-left">{{ ticket.raceName }}</span>
            </p>
          </td>
          <td rowspan="2" width="105" valign="top" class="kodtkt-cell-bordered-bottom-left">
            <p class="kodtkt-cell-align-center">
              <span class="kodtkt-font-italic kodtkt-margin-left">{{ $t('boarding.kodrive.depart') }}</span>
              <br>
              <span class="kodtkt-font-bold kodtkt-margin-left">{{ ticket.timeDep }}</span>
              <br>
              <span class="kodtkt-font-regular kodtkt-margin-left">{{ ticket.dateDep }}</span>
            </p>
          </td>
          <td rowspan="2" width="105" valign="top" class="kodtkt-cell-bordered-bottom-right">
            <p class="kodtkt-cell-align-center">
              <span class="kodtkt-font-italic kodtkt-margin-left">{{ $t('boarding.kodrive.arr') }}</span>
              <br>
              <span class="kodtkt-font-bold kodtkt-margin-left">{{ ticket.timeArr }}</span>
              <br>
              <span class="kodtkt-font-regular kodtkt-margin-left">{{ ticket.dateArr }}</span>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="2" width="280" class="kodtkt-cell-bordered-bottom-left">
            <p>
              <span class="kodtkt-font-italic kodtkt-margin-left">{{ $t('boarding.kodrive.st-depart') }}</span>
              <br>
              <span class="kodtkt-font-bold kodtkt-margin-left">{{ ticket.stDepName }}</span>
              <br>
              <span class="kodtkt-font-italic kodtkt-margin-left">{{ $t('boarding.kodrive.st-arr') }}</span>
              <br>
              <span class="kodtkt-font-bold kodtkt-margin-left">{{ ticket.stArrName }}</span>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="3" width="310" height="20" class="kodtkt-cell-bordered-left">
            <p>
              <span class="kodtkt-font-italic kodtkt-margin-left">{{ $t('boarding.kodrive.passenger') }}</span>
              <br>
              <span class="kodtkt-font-bold kodtkt-margin-left">{{ ticket.name + ' ' + ticket.lastName }}</span>
            </p>
          </td>
          <td width="166" class="kodtkt-cell-bordered-none">
            <p class="kodtkt-cell-align-center">
              <span class="kodtkt-font-italic kodtkt-margin-left">{{ $t('boarding.kodrive.seat') }}</span>
              <br>
              <span class="kodtkt-font-bold kodtkt-margin-left">{{ ticket.place }}</span>
            </p>
          </td>
          <td colspan="2" width="217" class="kodtkt-cell-bordered-right kodtkt-cell-padding-right">
            <p class="kodtkt-cell-align-right">
              <span class="kodtkt-font-italic kodtkt-margin-left">{{ $t('boarding.kodrive.sum') }}</span>
              <br>
              <span class="kodtkt-font-bold kodtkt-margin-left">{{ ticket.price + ' ' + currencySymbol }}</span>
            </p>
          </td>
        </tr>
        <tr class="kodtkt-row-margin-top">
          <td colspan="3" width="310" class="kodtkt-cell-bordered-bottom-left">
            <p>
              <br>
              <span class="kodtkt-font-italic kodtkt-margin-left">{{ $t('boarding.kodrive.curr') }}</span>
              <br>
              <span class="kodtkt-font-bold kodtkt-margin-left">{{ ticket.carrierName }}</span>
            </p>
          </td>
          <td colspan="3" width="391" class="kodtkt-cell-bordered-bottom-right kodtkt-cell-padding-right">
            <p class="kodtkt-cell-align-right">
              <br>
              <span class="kodtkt-font-italic kodtkt-margin-left">{{ $t('boarding.kodrive.insurance') }}</span>
              <br>
              <span class="kodtkt-font-sm-italic kodtkt-margin-left">
                {{ insurance }}
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="2" width="196" height="40" class="kodtkt-cell-bordered-bottom-left kodtkt-cell-valign-middle">
            <span class="kodtkt-font-italic kodtkt-margin-left">{{ $t('boarding.kodrive.tickets[0]') }}</span>
          </td>
          <td colspan="2" width="280" class="kodtkt-cell-bordered-bottom-left kodtkt-cell-valign-middle">
            <span class="kodtkt-font-bold kodtkt-margin-left">{{ ticket.brand.brand }}</span>
          </td>
          <td colspan="2" width="217" class="kodtkt-cell-bordered-bottom-right kodtkt-cell-align-right kodtkt-cell-padding-right">
            <span>
              <img alt="logo" :src="ticket.brand.logo.data"
                    name="LogoAgent" class="kodtkt-logo-size"/>
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="2" width="196" height="40" class="kodtkt-cell-bordered-bottom-left kodtkt-cell-valign-middle">
            <span class="kodtkt-font-italic kodtkt-margin-left">{{ $t('boarding.kodrive.tickets[1]') }}</span>
          </td>
          <td colspan="2" width="280" class="kodtkt-cell-bordered-bottom-left kodtkt-cell-valign-middle">
            <span class="kodtkt-font-bold kodtkt-margin-left">
              ТОВ &quot;КОДРАЙВ&quot;
            </span>
          </td>
          <td colspan="2" width="217" class="kodtkt-cell-bordered-bottom-right kodtkt-cell-align-right kodtkt-cell-padding-right kodtkt-cell-valign-middle">
            <span>
              <img :src="logoCustomer" name="LogoCustomer" class="kodtkt-logo-size" />
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="2" width="196"  height="40" class="kodtkt-cell-bordered-bottom-left kodtkt-cell-valign-middle">
            <span class="kodtkt-font-italic kodtkt-margin-left">{{ $t('boarding.kodrive.support') }}</span>
          </td>
          <td colspan="4" width="504" class="kodtkt-cell-bordered-no-top kodtkt-cell-padding-right kodtkt-cell-valign-middle">
            <span class="kodtkt-font-sm kodtkt-margin-left">
              +38 093 508 5577, +38 095 508 5577, +38 096 508 5577, support@inbus.com.ua
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  props: {
    common: {
      type: Object,
      required: true,
    },
    ticket: {
      type: Object,
      required: true,
    },
  },
  computed: {
    insurance() {
      return `${this.ticket.insurName}, ${this.ticket.insurAddr}`;
    },
    luggagePrice() {
      return this.ticket.luggagePrice ? this.ticket.luggagePrice : '-';
    },
    host() {
      return this.ticket.brand.site;
    },
    logoImg() {
      return this.ticket.brand.logo ? this.ticket.brand.logo.data : '';
    },
    QRCodeImg() {
      return this.ticket.brand.qrcode ? this.ticket.brand.qrcode.data : '';
    },
    logoCustomer() {
      // eslint-disable-next-line max-len
      return 'data:image/jpeg;base64,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';
    },
    currencySymbol() {
      const name = this.$root.octobusCurrency ? this.$root.octobusCurrency.name : '';
      const currency = name || this.$root.octobusCurrencyObj;

      return typeof currency === 'object' ? currency.name : currency;
    },
  },
};
</script>

<style lang="scss">
.ticket-wrapper {
    width: 732px;
    padding: 8px;
    position: relative;
    margin: auto;
    margin-top: 25px;
    margin-bottom: 10px;
}

.kodtkt-table {
  page-break-after: always;
  line-height: 1.3;
}

.kodtkt-font-bold {
  font-family: "Arial", serif;
  font-size: 11pt;
  font-weight: bold !important;
}

.kodtkt-font-italic {
  font-family: "Arial", serif;
  font-size: 10pt;
  font-style: italic !important;
}

.kodtkt-font-regular {
  font-family: "Arial", serif;
  font-size: 10pt;
}

.kodtkt-font-sm-italic {
  font-family: "Arial", serif;
  font-size: 9pt;
  font-style: italic !important;
}

.kodtkt-font-sm {
  font-family: "Arial", serif;
  font-size: 9pt;
}

.kodtkt-margin-left {
    margin-left: 0.1cm;
}

.kodtkt-cell-bordered-none {
  border: none;
  padding: 0cm;
}

.kodtkt-cell-bordered-left {
  border-top: none;
  border-bottom: none;
  border-left: 1px solid black;
  border-right: none;
  padding: 0cm;
}

.kodtkt-cell-bordered-right {
  border-top: none;
  border-bottom: none;
  border-left: none;
  border-right: 1px solid black;
  padding: 0cm;
}

.kodtkt-cell-bordered-no-top {
  border-top: none;
  border-bottom: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
  padding: 0cm;
}

.kodtkt-cell-bordered-bottom-left {
  border-top: none;
  border-bottom: 1px solid black;
  border-left: 1px solid black;
  border-right: none;
  padding: 0cm;
}

.kodtkt-cell-bordered-bottom-right {
  border-top: none;
  border-bottom: 1px solid black;
  border-left: none;
  border-right: 1px solid black;
  padding: 0cm;
}

.kodtkt-cell-bordered-bottom {
  border-top: none;
  border-bottom: 1px solid black;
  border-left: none;
  border-right: none;
  padding: 0cm;
}

.kodtkt-cell-padding-right {
  padding-right: 0.15cm;
}

.kodtkt-cell-align-center {
  text-align: center !important;
}

td.kodtkt-cell-valign-middle {
  vertical-align: middle !important;
}

.kodtkt-cell-align-right {
  text-align: right !important;
}

.kodtkt-row-margin-top {
  margin-top: 0.15cm;
}

.kodtkt-ticket-border{
  border-width: 0px;
  border-style: none;
  margin: auto;
  margin-top: 25px;
  margin-bottom: 10px;
  width: 734px;
  padding: 8px;
  position: relative;
}

.kodtkt-logo-size {
  width: auto;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/BoardingTicket/_shared/kodrive/ChangeBlank.vue